import { useEffect, useState } from 'react';
import { acquireObjectUrl, releaseObjectUrl } from '@/lib/media';

/** Returns an object URL for a media id, automatically acquiring/releasing it as the id changes or the component unmounts. */
export function useObjectUrl(mediaId: string | null | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    if (!mediaId) {
      setUrl(null);
      return;
    }
    acquireObjectUrl(mediaId).then((resolved) => {
      if (!cancelled) setUrl(resolved);
    });
    return () => {
      cancelled = true;
      releaseObjectUrl(mediaId);
    };
  }, [mediaId]);

  return url;
}
